import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TabProps, tabStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-tab',
  template: `
    <button
      #ref
      role="tab"
      type="button"
      [disabled]="isDisabled"
      [attr.aria-controls]="'tabs--tab-panel-' + id"
      [attr.aria-selected]="isActive"
      [ngClass]="tab"
      [tabIndex]="isActive ? 0 : -1"
      (click)="activateTab()"
    >
      <ng-content></ng-content>
    </button>
  `,
})
export class TabComponent {
  @Input() isDisabled: boolean;
  @Input() id: TabProps['index'];
  @Input() content: TabProps['index'];
  @Input() isFocusable: boolean;
  @Input() css: TabProps['css'];

  @ViewChild('ref') ref: ElementRef;

  @Output()
  onClick = new EventEmitter();

  private _active: boolean;

  @Input()
  get isActive(): boolean {
    return this._active;
  }

  set isActive(value: boolean) {
    this._active = value;
    if (this.isActive && this.isFocusable) {
      this.ref.nativeElement.focus();
    }
  }

  public get tab(): string[] {
    return [
      tabStyles({
        isActive: this.isActive,
        isDisabled: this.isDisabled,
        isFocusable: this.isFocusable,
        css: this.css,
      }).className,
    ];
  }

  activateTab() {
    this.onClick.emit(this.id);
  }
}
